module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-levelbar clearfix"
  }, [_c('h4', {
    staticClass: "router-name fl"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('n3-breadcrumb', {
    staticClass: "breadcrumb fr"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('n3-breadcrumb-item', {
      key: item.id,
      attrs: {
        "active": index == _vm.list.length - 1
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v("\n        " + _vm._s(item.meta && item.meta.label || item.name) + "\n      ")])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47583a4f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/levelbar.vue
// module id = 307
// module chunks = 3